(function () {
  const PENDING_KEY = "one8:wishlist:pending";
  const PENDING_TTL_MS = 15 * 60 * 1000;
  const CUSTOMER_ID_KEYS = ["kp_customer_id", "kpCustomerId", "kp-customer-id"];
  const CUSTOMER_ID_RE = /^\d{5,20}$/;

  function readKwikpassCustomerId() {
    for (const store of ["localStorage", "sessionStorage"]) {
      for (const key of CUSTOMER_ID_KEYS) {
        let raw = null;
        try {
          raw = window[store].getItem(key);
        } catch (error) {
          continue;
        }
        if (!raw) continue;

        const id = String(raw).replace(/^"|"$/g, "").trim().split("/").pop();
        if (CUSTOMER_ID_RE.test(id)) return id;
      }
    }

    // Native Shopify session fallback — Kwikpass only operates in India, so
    // international shoppers log in through the hosted Shopify login and
    // their customer id comes from Shopify's page context.
    const sessionCid = String((window.__st && window.__st.cid) || "");
    if (CUSTOMER_ID_RE.test(sessionCid)) return sessionCid;

    return "";
  }

  function isIndiaVisitor() {
    // Primary signal: the active Shopify Market country for this visitor,
    // decided server-side by Shopify's geo routing.
    const marketCountry = String(
      (window.Shopify && window.Shopify.country) || "",
    ).toUpperCase();
    if (marketCountry) return marketCountry === "IN";

    // Fallback when the Shopify global is unavailable: device timezone.
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
      if (/kolkata|calcutta/i.test(tz)) return true;
    } catch (error) {
    }
    return new Date().getTimezoneOffset() === -330;
  }

  function redirectToShopifyLogin() {
    const returnTo = encodeURIComponent(
      window.location.pathname + window.location.search,
    );
    const locale = encodeURIComponent(
      (window.Shopify && window.Shopify.locale) || "en",
    );
    window.location = `/customer_authentication/login?return_to=${returnTo}&locale=${locale}`;
  }

  function openKwikpassLogin() {
    // Kwikpass only works for shoppers in India — everyone else goes to
    // the hosted Shopify login and returns with a Shopify session.
    if (!isIndiaVisitor()) {
      redirectToShopifyLogin();
      return;
    }

    if (typeof window.handleKpAndShopifyLogin === "function") {
      window.handleKpAndShopifyLogin();
      return;
    }

    setTimeout(function () {
      if (typeof window.handleKpAndShopifyLogin === "function") {
        window.handleKpAndShopifyLogin();
      } else {
        redirectToShopifyLogin();
      }
    }, 500);
  }

  function readPending() {
    let pending = null;
    try {
      pending = JSON.parse(window.localStorage.getItem(PENDING_KEY));
    } catch (error) {
      return null;
    }
    if (!pending || !pending.empi) return null;
    if (!(Date.now() - Number(pending.at) < PENDING_TTL_MS)) {
      clearPending();
      return null;
    }
    return pending;
  }

  function writePending(product) {
    try {
      window.localStorage.setItem(
        PENDING_KEY,
        JSON.stringify(Object.assign({}, product, { at: Date.now() })),
      );
    } catch (error) {
    }
  }

  function clearPending() {
    try {
      window.localStorage.removeItem(PENDING_KEY);
    } catch (error) {
    }
  }

  function getFullProductUrl(path) {
    if (!path) return window.location.href;
    const clean = String(path).split("?")[0];
    if (/^https?:\/\//i.test(clean)) return clean;
    return (
      window.location.origin + (clean.startsWith("/") ? clean : "/" + clean)
    );
  }

  // Mirrors quick-add.js's resolveWishlistVariantId so the pending record
  // captures the size the shopper picked before the login gate interrupted
  function resolveVariantId(variantRadios, button) {
    const fallback = button.getAttribute("data-variant-id") || null;
    if (!variantRadios) return fallback;

    const fieldsets = Array.from(
      variantRadios.querySelectorAll("[data-variant-fieldset]"),
    );
    const selectedByPosition = {};
    let hasMissingSelection = false;

    fieldsets.forEach(function (fieldset, index) {
      const input = fieldset.querySelector("[data-input]:checked");
      if (!input) {
        hasMissingSelection = true;
        return;
      }
      const position = Number(fieldset.dataset.optionPosition) || index + 1;
      selectedByPosition[position] = input.value;
    });

    const selectedEntries = Object.entries(selectedByPosition);
    if (hasMissingSelection || !selectedEntries.length) return fallback;

    let variants;
    try {
      variants = JSON.parse(
        variantRadios.querySelector('script[type="application/json"]')
          .textContent,
      );
    } catch (error) {
      return fallback;
    }

    const matches = function (variant) {
      return selectedEntries.every(function (entry) {
        return variant["option" + entry[0]] === entry[1];
      });
    };

    const match =
      variants.find(function (variant) {
        return matches(variant) && variant.available;
      }) || variants.find(matches);

    return match ? match.id : fallback;
  }

  // The PDP heart shares its section with the size picker; cart item wishlist
  // links sit in sections without one and keep their own variant
  function findSectionVariantPicker(button) {
    const section = button.closest(".shopify-section");
    if (!section) return null;

    const pickers = Array.from(
      section.querySelectorAll("variant-radios"),
    ).filter(function (picker) {
      return !picker.closest(".quick-add");
    });

    return (
      pickers.find(function (picker) {
        return picker.offsetParent !== null;
      }) ||
      pickers[0] ||
      null
    );
  }

  function addViaSwym(product, onDone) {
    const run = function (swat) {
      const onSuccess = function (addedItem) {
        const payload = Object.assign({}, product, addedItem || {});
        const eventName =
          (swat.JSEvents && swat.JSEvents.addedToWishlist) ||
          "sw:addedtowishlist";

        if (swat.evtLayer) {
          swat.evtLayer.dispatchEvent(
            new CustomEvent(eventName, { detail: { d: payload } }),
          );
        }

        if (typeof swat.updateWishlistCount === "function") {
          swat.updateWishlistCount();
        }

        if (swat.ui && typeof swat.ui.showSuccessNotification === "function") {
          swat.ui.showSuccessNotification({
            message:
              (window.variantStrings && window.variantStrings.addedToWishlist) ||
              "Added to wishlist",
          });
        }

        document.dispatchEvent(
          new CustomEvent("wishlist:state-changed", {
            detail: { productId: product.empi, wishlisted: true },
          }),
        );

        if (onDone) onDone();
      };

      const onError = function () {
        if (onDone) onDone();
      };

      if (typeof swat.addToWishList === "function") {
        swat.addToWishList(product, onSuccess, onError);
        return;
      }

      swat.fetchLists({
        callbackFn: function (lists) {
          const listId = lists && lists[0] && lists[0].lid;
          if (!listId) {
            onError();
            return;
          }
          swat.addToList(listId, product, onSuccess, onError);
        },
        errorFn: onError,
      });
    };

    if (window._swat) {
      run(window._swat);
    } else {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(run);
    }
  }

  // Completes a wishlist add that was interrupted by the login gate
  function resumePending() {
    const pending = readPending();
    if (!pending) return;
    if (!readKwikpassCustomerId()) return;

    clearPending();
    restoreScrollPosition(pending);

    addViaSwym({
      epi: Number(pending.epi),
      empi: Number(pending.empi),
      du: pending.du,
      source: pending.source || "collections-grid",
    });
  }

  function blockAndLogin(event, pending) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    pending.path = window.location.pathname;
    pending.scrollY = window.scrollY;

    writePending(pending);
    openKwikpassLogin();
  }

  // After the login reload, bring the shopper back to where they were when
  // they hit the login gate instead of leaving them at the top of the page
  function restoreScrollPosition(pending) {
    if (pending.path && pending.path !== window.location.pathname) return;

    // Already at (or near) the saved position — e.g. the login happened
    // in-place without a reload, or the browser restored scroll itself
    if (
      typeof pending.scrollY === "number" &&
      Math.abs(window.scrollY - pending.scrollY) < 50
    ) {
      return;
    }

    const target =
      document.querySelector(
        'product-card[data-product-id="' + pending.empi + '"]',
      ) ||
      document.querySelector(
        '[data-swaction="addToWishlist"][data-product-id="' +
          pending.empi +
          '"]',
      );

    const doScroll = function () {
      if (target && target.isConnected) {
        target.scrollIntoView({ block: "center", behavior: "auto" });
      } else if (typeof pending.scrollY === "number") {
        window.scrollTo(0, pending.scrollY);
      }
    };

    doScroll();

    // Re-apply once the page has fully loaded, since images and app embeds
    // shift the layout while loading
    if (document.readyState === "complete") {
      setTimeout(doScroll, 300);
    } else {
      window.addEventListener(
        "load",
        function () {
          setTimeout(doScroll, 100);
        },
        { once: true },
      );
    }
  }

  // Capture-phase so this runs before quick-add.js's and Swym's own handlers
  document.addEventListener(
    "click",
    function (event) {
      // Theme quick-add wishlist modal button
      const modalButton = event.target.closest("[data-add-to-wishlist]");
      if (modalButton && modalButton.closest(".quick-add")) {
        if (modalButton.disabled) return;

        const modal = modalButton.closest(".quick-add");
        const variantPicker = modal.querySelector(
          "variant-radios[data-allow-incomplete-submit]",
        );
        if (variantPicker?.reportMissingSelections?.()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        if (readKwikpassCustomerId()) return; // logged in — let the normal flow run

        blockAndLogin(event, {
          epi: Number(
            resolveVariantId(modal.querySelector("variant-radios"), modalButton),
          ),
          empi: Number(
            (modal && modal.dataset.productId) || modalButton.dataset.productId,
          ),
          du:
            (modal && modal.dataset.productUrl) ||
            modalButton.dataset.productUrl ||
            getFullProductUrl(window.location.pathname),
          source: "collections-grid",
        });
        return;
      }

      // Swym-bound buttons (PDP custom heart, cart item wishlist links)
      const swymButton = event.target.closest('[data-swaction="addToWishlist"]');
      if (!swymButton || swymButton.disabled) return;

      // An already-wishlisted state means this click removes — let it through
      if (swymButton.classList.contains("swym-added")) return;

      // The PDP heart asks for a size like add to cart does, for guests and
      // logged-in shoppers alike, then saves the size that was picked
      const variantPicker = findSectionVariantPicker(swymButton);
      if (variantPicker) {
        if (
          variantPicker.hasAttribute("data-allow-incomplete-submit") &&
          variantPicker.reportMissingSelections?.()
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        const variantId = resolveVariantId(variantPicker, swymButton);
        if (variantId) swymButton.dataset.variantId = String(variantId);
      }

      if (readKwikpassCustomerId()) return; // logged in — let the normal flows run

      blockAndLogin(event, {
        epi: Number(swymButton.dataset.variantId),
        empi: Number(swymButton.dataset.productId),
        du:
          swymButton.dataset.productUrl ||
          getFullProductUrl(window.location.pathname),
        source: "product-page",
      });
    },
    true,
  );

  document.addEventListener("kp-data-sent", resumePending);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", resumePending);
  } else {
    resumePending();
  }
})();
